import { Helmet } from 'react-helmet';
import {
    Box, Button, Card, CardHeader, CardActions, CardContent, Chip,
    Container, Divider, Link,
    Grid, Typography,
    usePagination,
    MenuItem,
    Select,
    TextField,
    InputAdornment,
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo } from "react";
import newsService from "../../../services/news.service";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import imgNew from "../../../assets/images/home/banner-image.svg";
import iconArrow from "../../../assets/images/news/icon-arrow.svg";
import iconSearch from "../../../assets/images/news/search-on-data.svg";
import iconNews from "../../../assets/images/news/icon-new.svg";
import cssVariables from "../../../theme/cssVariables";
import Search from "@mui/icons-material/Search";
import * as Util from "../../../services/global.service";

import defaultBanner from "../../../assets/images/announcement/default.jpg"

const styles = {
    path: {
        color: "#68717A",
    },
    paPlanning: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
    },
    content: {
        background: "#FFFFFF",
        "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)",
        "border-radius": "10px",
        padding: "17px 22px",
        height: "100%",
    },
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        "background-color": "#fff",
        height: "220px",
        "box-shadow": "0px 0px 5px rgb(0 0 0 / 10%)",
        "border-radius": "10px",
        "justify-content": "center",
        "align-items": "center",
    },
    twoContent: {
        display: "flex",
        "justify-content": "center",
        "flex-direction": "row",
        "align-items": "center",
    },
    boxTwoContent: {
        display: "flex",
        "justify-content": "space-between",
        "flex-direction": "row",
        "align-items": "center",
    }
};

const news = [
    {
        id: 1,
        photo: "",
        title: "เริ่มวางแผนข้อตกลง และส่งให้หัวหน้างาน 1 มกราคม พ.ศ. 2565 นี้เป็นต้นไป",
        description: "ระบบทำการเปิดเพื่อให้วางแผนข้อตกลงภาระงาน โดยขอความร่วมมือทุกท่านเข้าไปทำ ข้อตกลงให้ครบหลักเกณฑ์และเงื่อนไข ก่อนส่งให้หัวหน้างานของท่านอนุมัติภายในวันที่ 30 มกราคม พ.ศ.2565",
        tag: [{ name: "Rubric" }],
        agency: "IPOP PMS",
        date: "2021-12-13 17:09:47",
    },
    {
        id: 2,
        photo: "",
        title: "ขอความร่วมมือในการเข้าไปลงข้อมูลเป้าหมายของปี พ.ศ.2565 ภายในวันที่ 31 ธันวาคม พ.ศ.​2564",
        description: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
        tag: [{ name: "Goals" }],
        agency: "NIDA",
        date: "2021-12-13 17:09:47",
    },
    {
        id: 3,
        photo: "",
        title: "เริ่มต้นใช้ระบบ IPOP PMS ตั้งแต่ 21 ธันวาคม พ.ศ. 2565 เป็นต้นไป",
        description: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
        tag: [{ name: "Goals" }, { name: "Competency" }],
        agency: "IPOP PMS",
        date: "2021-12-13 17:09:47",
    },
    {
        id: 4,
        photo: "",
        title: "วางแผนข้อตกลง เปิดให้ลงถึงวันที่ 30 มกราคม พ.ศ 2565 เท่านั้น",
        description: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
        tag: [{ name: "Rubric" }],
        agency: "NIDA",
        date: "2021-12-13 17:09:47",
    },
    {
        id: 5,
        photo: "",
        title: "ประกาศ เรื่อง ภาระงานสายวิชาการ ประจำปี พ.ศ.​ 2565 ",
        description: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
        tag: [{ name: "Rubric" }, { name: "Goals" }, { name: "Competency" }],
        agency: "NIDA",
        date: "2021-12-13 17:09:47",
    },
    {
        id: 6,
        photo: "",
        title: "ประกาศ เรื่อง ภาระงานสายวิชาการ ประจำปี พ.ศ.​ 2565 ",
        description: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
        tag: [{ name: "Rubric" }, { name: "Goals" }, { name: "Competency" }],
        agency: "NIDA",
        date: "2021-12-13 17:09:47",
    },
    {
        id: 7,
        photo: "",
        title: "ประกาศ เรื่อง ภาระงานสายวิชาการ ประจำปี พ.ศ.​ 2565 ",
        description: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
        tag: [{ name: "Rubric" }, { name: "Goals" }, { name: "Competency" }],
        agency: "NIDA",
        date: "2021-12-13 17:09:47",
    },
    {
        id: 8,
        photo: "",
        title: "ประกาศ เรื่อง ภาระงานสายวิชาการ ประจำปี พ.ศ.​ 2565 ",
        description: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
        tag: [{ name: "Rubric" }, { name: "Goals" }, { name: "Competency" }],
        agency: "NIDA",
        date: "2021-12-13 17:09:47",
    },
    {
        id: 9,
        photo: "",
        title: "ประกาศ เรื่อง ภาระงานสายวิชาการ ประจำปี พ.ศ.​ 2565 ",
        description: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
        tag: [{ name: "Rubric" }, { name: "Goals" }, { name: "Competency" }],
        agency: "NIDA",
        date: "2021-12-13 17:09:47",
    },
    {
        id: 10,
        photo: "",
        title: "ประกาศ เรื่อง ภาระงานสายวิชาการ ประจำปี พ.ศ.​ 2565 ",
        description: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
        tag: [{ name: "Rubric" }, { name: "Goals" }, { name: "Competency" }],
        agency: "NIDA",
        date: "2021-12-13 17:09:47",
    },
    {
        id: 11,
        photo: "",
        title: "ประกาศ เรื่อง ภาระงานสายวิชาการ ประจำปี พ.ศ.​ 2565 ",
        description: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
        tag: [{ name: "Rubric" }, { name: "Goals" }, { name: "Competency" }],
        agency: "NIDA",
        date: "2021-12-13 17:09:47",
    },
    {
        id: 12,
        photo: "",
        title: "ประกาศ เรื่อง ภาระงานสายวิชาการ ประจำปี พ.ศ.​ 2565 ",
        description: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
        tag: [{ name: "Rubric" }, { name: "Goals" }, { name: "Competency" }],
        agency: "NIDA",
        date: "2021-12-13 17:09:47",
    },
];

const useStyles = makeStyles({
    swiperStyles: {
        paddingTop: "10px !important"

    },
    iconContainer: {
        '& svg': {
            width: "45px",
            height: "45px"
        }
    },
    statusBadge: {
        maxWidth: "150px",
        borderRadius: "5px",
        padding: "5px 12px",
        margin: "0",
    },
    processBgGoals: {
        background: "#4085C9 !important",
        "&:hover": {
            backgroundColor: "#4085C9 !important",
        },
    },

    processBgRubric: {
        background: "#85AEB0 !important",
    },

    processBgCompetency: {
        background: "#958CCB !important",
    },
    styleTextBtSmall: {
        color: "##949494 !important",
        fontWeight: "600",
        fontSize: "12px",
        lineHeight: "15px",
    },

})

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },

    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? `${t('label.previous')}`
                                        : type === "next"
                                            ? `${t('label.next')}`
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}



const TypeNews = () => {

    const { t } = useTranslation();

    const [dataNews, setDataList] = React.useState([]);
    const [dataNewSerach, setDataNewSerach] = React.useState([]);
    let getTypeNew = () => {
        newsService.tags(type).then(
            (response) => {
                setDataList(response.data)
            },
        );
    }

    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }

    const [filteredList, setFilteredList] = React.useState([]);
    const [groupedReq, setGroupReq] = React.useState([]);
    const [perPage, setPerPage] = React.useState(8);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };

    // handle search
    const [search, setSearchValue] = React.useState("");
    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };


    useEffect(() => {
        dataSerach()
    }, [search]);

    useEffect(() => {
        setDataNewSerach(dataNews);
    }, [dataNews]);

    const dataSerach = () => {
        let result = []

        let dataSerach = JSON.parse(JSON.stringify(dataNews))

        if (search !== "" && dataSerach !== undefined) {
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some((key) => {
                    if (key === 'title' || key === 'description' || key === 'excerpt' || key === 'client') {
                        return rs[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                    }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        // setDataNewSerach(result);
        setFilteredList(result)
    }

    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };
    const handleTotalPage = () => {
        const List = filteredList
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };
    // update qty for each status when list changed
    useEffect(() => {
        handleTotalPage();

    }, [filteredList, perPage]);

    useEffect(() => {
        setFilteredList(dataNewSerach)
    }, [dataNewSerach]);



    useEffect(() => {

        if (dataNews !== undefined && dataNews !== null && dataNews !== "null") {
            setFilteredList(dataNews);
            getTypeNew();
        }
    }, []);

    const [valueTab, setValueTab] = React.useState("all");

    useEffect(() => {
        handleTotalPage();
    }, [valueTab]);
    const currentTableData = useMemo(() => {
        handleTotalPage();
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return filteredList
            .slice(firstPageIndex, lastPageIndex);
    }, [filteredList, currentPage, perPage]);

    let { type } = useParams();
    useEffect(() => {


    }, []);

    const handleGoToDetail = (e) => {
        navigate(`/kpi/announcement/contentnews/${e}`, { replace: false });
    }

    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const seq = () => {
        let seqs = 0
        let order = 0
        if (news !== undefined && news !== null && news !== "null") {
            for (let index = 0; index <= news.length - 1; index++) {
                if (seqs < news[index].seq) {
                    seqs = news[index].seq
                    order = index
                }
            }
            return news[order]
        }
        // return {}
    }
    const Root = styled('div')(({ theme }) => ({
        background: '#FFFFFF', "box-shadow": '0px 0px 10px rgba(0, 0, 0, 0.1)', "border-radius": '10px', margin: '20px',
        ['@media (max-width:780px)']: {
            width: "calc(100% - 40px)",
        },
        ['@media (min-width:781px)']: {
            width: "calc(50% - 40px)",
        },
        ['@media (min-width:1000px)']: {
            width: "calc(33.33% - 40px)",
        },
        ['@media (min-width:1300px)']: {
            width: "calc(25% - 40px)",
        },
    }));



    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3,
                    width: '100%'
                }}
            >
                <Container maxWidth="xl">

                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t("news.label.homePage")}</span> / <span style={styles.link} onClick={() => clickLink('/kpi/announcement/allnews')} >{t("news.label.news")}</span> /  <span style={styles.end}> {t("news.label.search")}</span></Typography>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs sm md lg>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }} >
                                <Box sx={{ width: "100%" }}>
                                    <Typography fontSize={36} color="#404349" lineHeight="39.6px" paddingBottom="14px" fontWeight="600px">
                                        {t("news.label.news")}
                                    </Typography>
                                    <Box sx={{ display: "flex", alignItems: "Center", justifyContent: "space-between" }}>
                                        <Box sx={{ display: "flex", alignItems: "Center", justifyContent: "space-between" }}>
                                            {/* <Box sx={{
                                                display: "flex", flexDirection: "row", alignItems: "Center", cursor: 'pointer', "&:hover": {
                                                    textDecoration: "underline"
                                                },
                                            }} onClick={() => navigate(-1)} >
                                                <img src={iconArrow} style={{ maxWidth: '22px', maxHeight: '13px' }}>

                                                </img>

                                                <Typography fontSize={18} lineHeight="19.8px" fontWeight="400px" sx={{ paddingLeft: '8px' }}>
                                                    ย้อนกลับ
                                                </Typography>
                                            </Box> */}
                                            <Typography fontSize={18} lineHeight="19.8px" fontWeight="400px" color="#404349">
                                                {t("news.label.reSearch")} <span style={{ fontWeight: "500" }}>"{type}"</span>  {t("news.label.find")} {formatData(dataNews.length, 0)} {t("news.label.result")}
                                            </Typography>
                                        </Box>
                                        <Grid item sm={12} xs={12} md={4} ml="auto" mr="20px">
                                            <TextField
                                                id="input-with-icon-textfield"
                                                fullWidth
                                                placeholder={t("news.label.search")}
                                                size="small"
                                                sx={{ background: "#fff" }}
                                                className="searchTextField-h48"
                                                value={search}
                                                onChange={handleSearch}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <Search style={{ color: "#C4C4C4" }} />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    </Box>
                                </Box>
                            </Box>


                            <Box sx={{ display: "flex", flexFlow: "row wrap", width: '100%' }}>

                                {
                                    currentTableData.length > 0 ?
                                        currentTableData.map(item => {
                                            return (

                                                <Root >
                                                    <Box sx={{ padding: '20px' }}>
                                                        <Box sx={{ borderRadius: '5px', maxWidth: '100%', maxHeight: '100%', height: '100%', width: '100%' }}>
                                                            <img src={item?.thumbnail || defaultBanner} style={{ maxWidth: '100%', maxHeight: '100%', height: '100%', width: '100%', borderRadius: '5px' }}>

                                                            </img>
                                                        </Box>
                                                        <Typography color="#404349" sx={{ wordBreak: "break-word", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: "2", WebkitBoxOrient: "vertical", paddingTop: "10px", cursor: 'pointer' }} onClick={() => handleGoToDetail(item?.serial)}>
                                                            {formatData(item?.title, "-")}
                                                        </Typography>

                                                        {/* <Box sx={{ display: "flex", paddingTop: "10px", flexFlow: "row wrap" }}>
                                                            {
                                                                item?.tags.map(itemname => (
                                                                    <Button sx={{ "border-radius": '22px', '&:last-child': { marginRight: '0px' }, marginRight: '10px', marginTop: '10px', padding: "10px 15px" }}
                                                                        className={classes.processBgGoals}>
                                                                        <Typography fontSize={12} lineHeight="14px" color="#FFFFFF" >
                                                                            {itemname}
                                                                        </Typography>
                                                                    </Button>
                                                                )
                                                                )
                                                            }
                                                        </Box> */}

                                                        <Typography fontSize={12} lineHeight="14px" fontWeight={400} color="#949494" sx={{ paddingTop: '10px' }}>
                                                            <span className={classes.styleTextBtSmall}>{formatData(item?.client, "-")}</span>  {Util.dateDayFormat(item?.start_at, "-")}
                                                        </Typography>
                                                    </Box>

                                                </Root>


                                            )
                                        }
                                        )
                                        :
                                        <Box sx={{ display: 'flex', justifyContent: 'center !important', alignItems: 'center', height: '100%', minHeight: '300px', width: '100%' }}>
                                            <Grid display='flex' justifyContent='center' flexDirection='column' alignItems='center' >
                                                <img src={iconSearch} style={{ maxWidth: '120px', maxHeight: '110px', height: '100%', width: '100%' }}>

                                                </img>
                                                <Typography fontSize={16} lineHeight="24px" fontWeight={400} color="#949494" sx={{ paddingTop: '20px' }}>
                                                    {t("news.label.noNews")}
                                                </Typography>
                                            </Grid>
                                        </Box>
                                }
                            </Box>


                        </Grid>

                        {filteredList?.length > 0 ?
                            <Grid container mt={1} spacing={2} sx={{ padding: '0px 15px 15px 40px' }} >
                                <Grid item xs sm md display="flex" alignItems="center">
                                    <Box mr={1}>
                                        <Typography variant="s14_fw400" >{t("label.showMaxItems")}</Typography>
                                    </Box>
                                    <Select
                                        id="pagination"
                                        variant="outlined"
                                        defaultValue={5}
                                        value={perPage}
                                        onChange={handlePerPageChange}
                                        displayEmpty
                                        size="small"
                                        className="white-bg"
                                    >
                                        <MenuItem value={8}>
                                            <Typography style={{ fontWeight: "300" }}>8</Typography>
                                        </MenuItem>
                                        <MenuItem value={20}>
                                            <Typography style={{ fontWeight: "300" }}>20</Typography>
                                        </MenuItem>
                                        <MenuItem value={40}>
                                            <Typography style={{ fontWeight: "300" }}>40</Typography>
                                        </MenuItem>
                                    </Select>
                                </Grid>
                                <Grid item display="flex" alignItems="center" ml="auto">
                                    <Typography variant="s14_fw400">
                                        {t('label.page')}  {currentPage}  {t('label.of')}  {totalPage}
                                    </Typography>
                                </Grid>
                                <Grid item ml="auto" display="flex" alignItems="center">
                                    <CustomPagination
                                        setCurrentPage={handleSetCurrentPage}
                                        selected={currentPage}
                                        count={totalPage}
                                    ></CustomPagination>
                                </Grid>
                            </Grid>
                            : null}

                    </Grid>

                </Container>
            </Box>
        </>
    )
};
export default TypeNews;


